import React, { useState } from 'react';
const moment = require('moment-timezone');

const ChargesGridPlain = ({ expenses, setExpenses, alternateCustomer, setAlternateCustomer }) => {
    const [selectedRows, setSelectedRows] = useState([]);

    // Initialize each category if not present
    const initializedExpenses = {
        tax_expenses: expenses.tax_expenses || [],
        actual_expenses: expenses.actual_expenses || [],
        custom_brokerage_expenses: expenses.custom_brokerage_expenses || [],
    };

    const sampleConcepts = {
        tax_expenses: ['IGI', 'IVA', 'IVA/PREV', 'DTA', 'Prevalidacion', 'Multa', 'C.C.', 'Recargos'],
        actual_expenses: ['Maniobras', 'Muellaje', 'Revalidacion BL', 'Limpieza', 'Gastos Extras', 'Carga y Descarga', 'Previo', 'Serv. Extraordinarios', 'Reconocimiento', 'Acarreo', 'Vacio', 'Demoras', 'Gastos Fijos', 'Almacenajes', 'Multas'],
        custom_brokerage_expenses: ['Honorarios', 'Validacion', 'Contraprestacion', 'COVE', 'IVA Servicios']
    };

    const handleAdd = (category) => {
        const mexicoCityTime = moment.tz(new Date(), "America/Mexico_City");
        const newExpense = {
            tempId: Date.now().toString(), // Temporary ID for frontend use, not related to database
            concept: sampleConcepts[category][0], // Default to the first concept in the list
            amount: 0,
            date_added: mexicoCityTime.toDate(), // Convert to JavaScript Date object in Mexico City time
        };
        setExpenses({
            ...initializedExpenses,
            [category]: [...initializedExpenses[category], newExpense],
        });
    };


    const formatAmount = (value) => {
        // Remove any non-numeric characters except for the dot
        let cleanValue = value.replace(/[^0-9.]/g, '');

        // Ensure there's only one dot
        const parts = cleanValue.split('.');
        if (parts.length > 2) {
            cleanValue = parts[0] + '.' + parts.slice(1).join('');
        }

        // Ensure only two decimal places
        if (parts[1] && parts[1].length > 2) {
            cleanValue = parts[0] + '.' + parts[1].substr(0, 2);
        }

        return cleanValue;
    };

    const handleInputChange = (e, category, expenseId, field) => {
        let value = e.target.value;
        if (field === 'amount') {
            value = formatAmount(value);
        }
        setExpenses({
            ...initializedExpenses,
            [category]: initializedExpenses[category].map(expense => {
                if (expense.tempId === expenseId || expense._id === expenseId) {
                    return { ...expense, [field]: value };
                }
                return expense;
            }),
        });
    };



    const handleDelete = (category) => {
        console.log("Expenses before delete:", initializedExpenses[category]);
        console.log("Selected rows:", selectedRows);

        setExpenses({
            ...initializedExpenses,
            [category]: initializedExpenses[category].filter((expense) => {
                const expenseId = expense._id || expense.tempId;
                return !selectedRows.includes(expenseId);
            }),
        });
        setSelectedRows([]); // Clear the selected rows
    };



    return (
        <div className="p-1 text-sm bg-white shadow rounded-lg overflow-hidden">
            <div className="mb-4">
                <label htmlFor="alternateCustomer" className="block text-sm font-medium text-gray-700">
                    Alternate Customer
                </label>
                <input
                    type="text"
                    id="alternateCustomer"
                    name="alternateCustomer"
                    maxLength="100"
                    value={alternateCustomer}
                    onChange={(e) => setAlternateCustomer(e.target.value)}
                    placeholder="Enter alternate customer (optional)"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />
            </div>
            {["tax_expenses", "actual_expenses", "custom_brokerage_expenses"].map(category => (
                <div key={category} className="mb-8">
                    <h2 className="text-xl font-semibold mb-4 text-blue-900 capitalize">{category.replace('_', ' ')}</h2>
                    <table className="min-w-full text-left border border-blue-200 divide-y divide-blue-200">
                        <thead className="bg-blue-50">
                            <tr>
                                <th className="px-3 py-2">Select</th>
                                <th className="px-3 py-2">ID</th>
                                <th className="px-3 py-2">Concept</th>
                                <th className="px-3 py-2">Amount</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-blue-200">
                            {initializedExpenses[category].map(expense => (
                                <tr key={expense.tempId || expense._id}>
                                    <td className="border px-4 py-2">
                                        <input
                                            type="checkbox"
                                            checked={selectedRows.includes(expense.tempId || expense._id)}
                                            onChange={(e) => {
                                                const currentId = expense.tempId || expense._id;
                                                if (e.target.checked) {
                                                    setSelectedRows([...selectedRows, currentId]);
                                                } else {
                                                    setSelectedRows(selectedRows.filter(id => id !== currentId));
                                                }
                                            }}
                                        />
                                    </td>
                                    <td className="border px-4 py-2">{expense.tempId || expense._id}</td>
                                    <td className="border px-3 py-1">
                                        <select
                                            className="border rounded px-1 py-1 w-full"
                                            value={expense.concept}
                                            onChange={(e) => handleInputChange(e, category, expense.tempId || expense._id, 'concept')}
                                        >
                                            <option value="" disabled>Select Concept</option>
                                            {sampleConcepts[category].map(concept => (
                                                <option key={concept} value={concept}>{concept}</option>
                                            ))}
                                        </select>
                                    </td>
                                    <td className="border px-4 py-2">
                                        <input
                                            type="text"
                                            className="border rounded px-2 py-1 w-full"
                                            value={`$${expense.amount}`}
                                            onChange={(e) => handleInputChange(e, category, expense.tempId || expense._id, 'amount')}
                                            placeholder="$0.00"
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="mt-4 flex justify-start">
                        <button
                            className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded mr-2"
                            onClick={() => handleAdd(category)}
                        >
                            Add
                        </button>
                        <button
                            className="bg-red-500 hover:bg-red-600 text-white font-semibold px-4 py-2 rounded"
                            onClick={() => handleDelete(category)}
                        >
                            Delete Selected
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
};

ChargesGridPlain.defaultProps = {
    expenses: {
        tax_expenses: [],
        actual_expenses: [],
        custom_brokerage_expenses: []
    },
    setExpenses: () => { },
    alternateCustomer: '',
    setAlternateCustomer: () => {}
};

export default ChargesGridPlain;
